import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  static targets = ["element"];

  initialize() {
    this.orgID = this.data.get("org-id");
    this.filter = this.data.get("filter");
    this.selectizeInitialized = false;
    this.initializeSelectize();
  }

  initializeSelectize() {
    this.selectizeInitialized = true;
    var _orgId = this.orgID ? "&org_id=" + this.orgID : "";
    var _filter = this.data.get("filter") ? "&filter=" + this.filter : "";
    $(this.elementTarget).selectize({
      valueField: "id",
      labelField: "name",
      searchField: ["name"],
      create: false,
      closeAfterSelect: true,
      render: {
        option(item, escape) {
          return "<div>" +
            "<span>" + escape(item.name) + "<span>" +
            "</div>";
        }
      },
      load(query, callback) {
        $.ajax({
          url: "/api/v1/teams?q=" + encodeURIComponent(query) + _orgId + _filter,
          type: "GET",
          error() {
            callback();
          },
          success(res) {
            callback(res.teams.slice(0, 10));
          }
        });
      },
      onInitialize() {
        try {
          var existingOptions = JSON.parse(this.$input.attr("data-selectize-value"));
          var self = this;
          if (Object.prototype.toString.call(existingOptions) === "[object Array]") {
            existingOptions.forEach(function (existingOption) {
              self.addOption(existingOption);
              self.addItem(existingOption[self.settings.valueField]);
            });
          } else if (typeof existingOptions === "object") {
            self.addOption(existingOptions);
            self.addItem(existingOptions[self.settings.valueField]);
          }
        } catch (e) {
          e;
        }
      }
    });
  }
}